export const SIGNUP_PAGE = "/signup";
export const LOGIN_PAGE = "/login";
export const SALES_PAGE = "/sales";
export const SALES_EDIT_PAGE = "/sales/edit/:editId";
export const PRODUCTS_PAGE = "/products";
export const DASHBOARD_PAGE = "/dashboard";
export const STOCK_PAGE = "/stock";
export const BARCODE_PAGE = "/stock/barcode";
export const SALES_HISTORY_PAGE = "/sales/history";
export const REFUND_PAGE = '/refund';
export const REFUNDS_HISTORY_PAGE = "/refund/history";
export const SETTINGS_PAGE = "/settings";
export const PROFILE_PAGE = "/profile";
export const INVENTORY_PAGE = "/inventory";
export const PURCHASES_PAGE = "/purchases";
export const PURCHASES_HISTORY_PAGE = "/purchases/history";





